import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { City, FirebaseService, AuthService } from "src/app/core";
import { Router } from "@angular/router";
import {
  MDBModalRef,
  MDBModalService,
  ToastService
} from "ng-uikit-pro-standard";
import { ConfirmCityComponent } from "../../popups/confirm-city/confirm-city.component";

@Component({
  selector: "ll-add-city-form",
  templateUrl: "./add-city-form.component.html",
  styleUrls: ["./add-city-form.component.scss"]
})
export class AddCityFormComponent implements OnInit {
  city: City;
  image = "";
  title = "Add City";
  button = "Add";
  active_venues = 0;

  form = new FormGroup({
    city_name: new FormControl(""),
    state: new FormControl(""),
    isActive: new FormControl("true")
  });
  constructor(
    public fb: FirebaseService,
    public modalRef: MDBModalRef,
    private modalService: MDBModalService,
    private toast: ToastService
  ) {}

  ngOnInit() {
    if (this.city != null) this.edit();
  }

  edit() {
    this.form = new FormGroup({
      city_name: new FormControl(this.city.city_name),
      state: new FormControl(this.city.state),
      isActive: new FormControl(this.city.is_active ? "true" : "false")
    });
    this.active_venues = this.city.active_venues;
    this.image = this.city.image;
    this.title = "Edit City";
    this.button = "Save";
  }

  imageSelected = (): boolean => this.image != "";

  async validate() {
    //Step 1: Is valid city?
    let cityname = this.form.value["city_name"];
    let state = this.form.value["state"];

    let geo = await this.fb.city.getGeopoint(cityname, state);
    if (geo == null || !this.isValid(cityname.toLowerCase()))
      return this.error("Please enter a valid city!");

    //Step 2: Is a state selected?
    if (state == "") return this.error("Please select a state!");

    //Step 3: Does this city already exist?
    if (
      this.city == null &&
      this.fb.city.cities
        .map(city => city.city_name + city.state)
        .includes(cityname + state)
    )
      return this.error("The provided city already exists!");

    //Step 4: Is image provided?
    if (this.image == "")
      return this.error("Please provide an image for the city!");

    //Step 5: Have user confirm if editing city with active venues
    if (this.form.value["isActive"] == "false" && this.active_venues > 0)
      return this.confirm();
    else return this.submit();
  }

  isValid(input: string) {
    return /^[a-z][a-z\s]*$/.test(input);
  }

  confirm() {
    this.modalRef.hide();
    this.modalRef = this.modalService.show(ConfirmCityComponent, {
      ignoreBackdropClick: true,
      class: "modal-side modal-center-right",
      containerClass: "right",
      animated: true,
      data: {
        active_venues: this.city.active_venues
      }
    });
    this.modalRef.content.action.subscribe((result: boolean) => {
      if (result) {
        this.submit();
      }
    });
  }

  error(msg: string) {
    this.toast.error(msg);
  }

  async submit() {
    //Step 0: Instantiate Form Results
    const form = this.form.value;

    //Step 1: Initialize a new city object
    var newCity: City = this.fb.city.initCity();
    //Step 2: Populate city attributes that are extracted from form results
    newCity.city_name = form["city_name"];
    newCity.state = form["state"];
    newCity.is_active = form["isActive"] == "true";
    newCity.image = this.image;
    //Step 3: Get GeoPoint From Google Cloud Services Using City-Name and State (ex. Chicago, IL)
    newCity.coordinates = await this.fb.city.getGeopoint(
      form["city_name"],
      form["state"]
    );
    //Step 4: With the coordinates, get the timezone from Google Cloud Services (ex. America/Chicago)
    newCity.timezone = await this.fb.city.getTimezone(newCity.coordinates);
    //Step 5: Remove local attributes of object
    delete newCity.venues;
    delete newCity.active_venues;
    //Step 6: Push to Firestore
    this.fb.city.api.add(newCity);

    //Step 7: Close Modal
    this.modalRef.hide();

    //Step 8: Notify User of Successful update
    setTimeout(() => this.toast.success("City Updated!"), 2000);
  }

  async selectImage(event) {
    this.image = await this.fb.saveImage(event.target.files[0], "city_images/");
  }
}
